export class BaseService {
  //PULSE_API_BASE_URL = 'https://pwapidev.idtech.com';

  // PULSE_WEBAPI_URL = `${this.PULSE_API_BASE_URL}/pulseWebApi`;
  // PULSE_BREEZE_URL = `${this.PULSE_API_BASE_URL}/breeze/DCPulseBreeze`;
  //PULSE_SPA_API_URL = 'https://ppdev.idtech.com/api/pulsespa';

  constructor() {}
}
